window.NotifyAddRevenue = function(notiInfo) {

	var masterTagExists;
	var devMode;
	var prodMode;

	function InitValues() {
		masterTagExists = (typeof ADDREVENUE != 'undefined') && (typeof ADDREVENUE.sendEvent === 'function');
		devMode         = notiInfo.config.devMode;
		prodMode        = !devMode;
	}

	function TriggerConversionTag() {
		if (masterTagExists) {
			var objSale = notiInfo.conversionTag;

			ADDREVENUE.sendEvent(objSale.type, {
				'value': objSale.value,
				'currency': objSale.currency,
				'orderId': objSale.orderId
			});
		}
	}

	function TriggerNotifications() {
		if (prodMode) {
			TriggerConversionTag();
		}
	}

	function TriggerNotificationsSafely() {
		try {
			InitValues();
			TriggerNotifications();
		} catch (e) {
			console.log(e);
		}
	}

	TriggerNotificationsSafely();
}
